import { env } from "configs/EnvironmentConfig";
import { checkHaveToken } from "constants/actionAccess";
import fetch from "../auth/FetchInterceptor";
import fetchV2 from "../auth/FetchInterceptorV2";

const profileManagerService = {};

// getMyProfile
profileManagerService.getMyProfile = () => {
  return fetch({
    url: `${env.API_MSP}/user-profiles/my-profile`,
    method: "get",
  });
};

// getProfile
profileManagerService.getProfile = () => {
  if(!checkHaveToken()){
    return false
  }
  return fetchV2({
    url: `${env.API_MSP}/my/profile`,
    method: "get",
  });
};

// updateProfile
profileManagerService.updateProfile = ({ displayName, avatarId }) => {
  return fetchV2({
    url: `${env.API_MSP}/my/profile`,
    method: "post",
    data: {
      display_name: displayName,
      avatar_id: avatarId ? avatarId : undefined,
    },
  });
};

// getAvatar
profileManagerService.getAvatar = avatarId => {
  return fetchV2({
    url: `${env.API_MSP}/my/avatar/${avatarId}`,
    method: "get",
    responseType: "blob",
  });
};

// uploadAvatar
profileManagerService.uploadAvatar = data => {
  return fetchV2({
    url: `${env.API_MSP}/my/avatar`,
    method: "post",
    data,
  });
};

export default profileManagerService;
